import { vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = {
  class: "date-range-calendar"
};
const _hoisted_2 = {
  class: "selected-range"
};
const _hoisted_3 = {
  class: "selected-range-inputs"
};
const _hoisted_4 = ["aria-label"];
const _hoisted_5 = {
  class: "date-range-separator"
};
const _hoisted_6 = ["aria-label"];
const _hoisted_7 = {
  class: "calendar-header"
};
const _hoisted_8 = ["aria-label"];
const _hoisted_9 = {
  class: "calendar-title"
};
const _hoisted_10 = ["aria-label"];
const _hoisted_11 = {
  class: "calendar-weekdays"
};
const _hoisted_12 = {
  class: "calendar-grid"
};
const _hoisted_13 = ["onClick"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_withDirectives(_createElementVNode("input", {
    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $data.inputStart = $event),
    class: "date-input",
    type: "text",
    inputmode: "numeric",
    "aria-label": $options.startDateLabel,
    onChange: _cache[1] || (_cache[1] = (...args) => $options.handleManualInput && $options.handleManualInput(...args))
  }, null, 40, _hoisted_4), [[_vModelText, $data.inputStart, void 0, {
    trim: true
  }]]), _createElementVNode("span", _hoisted_5, _toDisplayString($options.rangeSeparator), 1), _withDirectives(_createElementVNode("input", {
    "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => $data.inputEnd = $event),
    class: "date-input",
    type: "text",
    inputmode: "numeric",
    "aria-label": $options.endDateLabel,
    onChange: _cache[3] || (_cache[3] = (...args) => $options.handleManualInput && $options.handleManualInput(...args))
  }, null, 40, _hoisted_6), [[_vModelText, $data.inputEnd, void 0, {
    trim: true
  }]])])]), _createElementVNode("div", _hoisted_7, [_createElementVNode("button", {
    type: "button",
    class: "calendar-nav",
    "aria-label": $options.previousMonthLabel,
    onClick: _cache[4] || (_cache[4] = (...args) => $options.goToPreviousMonth && $options.goToPreviousMonth(...args))
  }, [_createVNode(_component_font_awesome_icon, {
    icon: "chevron-left"
  })], 8, _hoisted_8), _createElementVNode("div", _hoisted_9, _toDisplayString($options.monthTitle), 1), _createElementVNode("button", {
    type: "button",
    class: "calendar-nav",
    "aria-label": $options.nextMonthLabel,
    onClick: _cache[5] || (_cache[5] = (...args) => $options.goToNextMonth && $options.goToNextMonth(...args))
  }, [_createVNode(_component_font_awesome_icon, {
    icon: "chevron-right"
  })], 8, _hoisted_10)]), _createElementVNode("div", _hoisted_11, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.weekdayLabels, weekday => {
    return _openBlock(), _createElementBlock("span", {
      key: weekday
    }, _toDisplayString(weekday), 1);
  }), 128))]), _createElementVNode("div", _hoisted_12, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.calendarDays, day => {
    return _openBlock(), _createElementBlock("button", {
      key: day.key,
      type: "button",
      class: _normalizeClass(["calendar-day", {
        'is-muted': !day.isCurrentMonth,
        'is-today': day.isToday,
        'is-range-start': day.key === $data.draftStart,
        'is-range-end': day.key === $data.draftEnd,
        'is-in-range': $options.isInRange(day.key)
      }]),
      onClick: $event => $options.selectDay(day.key)
    }, _toDisplayString(day.dayOfMonth), 11, _hoisted_13);
  }), 128))])]);
}